import { Typography } from 'antd';
import { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  children?: ReactNode;
}

export const PageHeader = ({ title, children }: PageHeaderProps) => {
  return (
    <div className='grid grid-rows-1 md:grid-flow-col items-center mb-6 gap-4 px-2 md:px-0'>
      <Typography.Title className='mb-0!'>{title}</Typography.Title>
      {children && <div className='md:justify-self-end'>{children}</div>}
    </div>
  );
}; 